import Image from 'next/image';
import { useState } from 'react';
import { useRouter } from 'next/router';
import { PreviewButton } from './Button';
import { PreviewContainer } from './Container';

export const PreviewToast = (props: React.HTMLAttributes<HTMLDivElement>) => {
  const { isPreview, asPath } = useRouter();
  const [open, setOpen] = useState(false);

  return isPreview ? (
    <div
      className="flex bg-background p-5 border border-base-100 fixed z-[9999] m-3 w-auto bottom-0 left-0 max-w-[320px] items-center rounded-lg transition-all"
      data-automation="ZA.preview-toast"
      {...props}
    >
      <Image
        data-automation="ZA.preview-toast-logo"
        onClick={() => setOpen(!open)}
        className="cursor-pointer"
        alt="DatoCMS logo"
        src="/dato.svg"
        height={24}
        width={24}
      />
      <PreviewContainer open={open}>
        <span className="text-sm">
          <PreviewButton
            href={`/api/disable-preview?slug=${encodeURIComponent(asPath)}`}
            data-automation="ZA.preview-toast-button"
          >
            Exit preview
          </PreviewButton>
        </span>
      </PreviewContainer>
    </div>
  ) : null;
};
